BookingApp.controller('HotelSearchController',function($scope,$http,$location,$filter,HotelServices,Slug){

    $scope.AdultCount = 1;
    $scope.ChildCount = 0;
    $scope.TravelerPopUp = false;

    $scope.TravellerOpen = false;


    $scope.OpenTravellerPopUp = function(){
        if(!$scope.TravellerOpen){
            $scope.TravellerOpen = true;
            var ClkFn = function(ev){
                var con = $('.fsbd');
                var Position = con.offset();
                var Width = con.outerWidth();
                var Heiht = con.outerHeight();
                var cond = ev.clientX > Position.left && ev.clientX < (Position.left + Width) && ev.clientY > Position.top && ev.clientY < (Position.top + Heiht)
                if(!$(ev.target).hasClass('travellerInput') && !cond){
                    $scope.TravellerOpen = false;
                    $scope.$apply();
                    window.removeEventListener('click',ClkFn,true)
                }
            }
            window.addEventListener('click',ClkFn,true)
        }
    }


    $scope.openDatepicker = function() {
        $scope.datePicker.opened = true;
    };

    var today = moment([]);
    today.add(2,'days');
    var NextDate = today.clone();
    NextDate.add(5,'days');

    $scope.datePicker = {
        opened: false,
        options:{
            autoUpdateInput:false,
            autoApply:true,
        },
        min: new Date(),
        date :{
            startDate: today,
            endDate: NextDate
        }
    };


    $scope.selected = undefined;

    $scope.getLocation = function(val) {
        return $http.get('/hotels/suggestion/queries/' + val)
            .then(function(response){
                return response.data.map(function(item){
                    return item;
                });
            });
    };


    $scope.travellers = function () {
        var total = 0;
        angular.forEach($scope.RoomGuests,function(room,index){
            total += room.NoOfAdults + room.NoOfChild;

        });
        return total;
    };

    $scope.RoomGuests	=	[
        {
            "NoOfAdults": 1,
            "NoOfChild": 0,
            "ChildAge": {'ch1':1,'ch2':1},
            "open":false,
        }
    ];

    $scope.popRoom = function(){
        $scope.RoomGuests.pop();
    }

    $scope.addRoom = function(){
        var newRoom = {"NoOfAdults": 1,"NoOfChild": 0,"ChildAge": {'ch1':1,'ch2':1},"open":true};
        $scope.RoomGuests.push(newRoom);
    }

    $scope.searchHotel = function(){
        var url = "hotels/hotels-in-" + Slug.slugify($scope.asyncSelected.destination) + "-" + $scope.asyncSelected.code +
                "-for-" + $scope.travellers() + "-guest-" + $scope.RoomGuests.length + "-room" +
                "-on-" + $scope.datePicker.date.startDate.format('YYYYMMDD') +
                "-till-" + $scope.datePicker.date.endDate.format('YYYYMMDD') + "-rooms-data-";

        angular.forEach($scope.RoomGuests,function(room,index){
            if(index) url += "-room-";
            url += room.NoOfAdults + "-" + room.NoOfChild + '-' + room.ChildAge.ch1 + '-' + room.ChildAge.ch2;
        });

        if($('.planTripPopup').length){
            $('.planTripPopup').modal('toggle');
        }

        fbq('track', 'Search', {
            search_string: 'hotel-'+url
        });
        $location.path(url).search({q:'',mnp:0,mxp:0,limit:10,page:1,star:''});
    }

    $scope.$on('set-search-data',function(event,param){
        console.log(param.City);
        $scope.datePicker.date.startDate = moment(param.CheckInDate, "YYYY-MM-DD");
        $scope.datePicker.date.endDate = moment(param.CheckOutDate, "YYYY-MM-DD");

        $scope.asyncSelected = param.City;
        $scope.RoomGuests = param.RoomGuests;

    })

    //Notify to parent that i am loaded so he can fire set request event
    $scope.$emit('HotelSearchControllerLoaded');
    //Listen the so we can set the search data

});